import s from "styled-components";
import { UncontrolledCollapse as Collapse } from "_c/Collapse";
import { CircleButton } from "_c/button";
import BaseCloseableMessage from "_c/CloseableMessage";

export const Wrap = s.div`
  padding: 10px;
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 1;
  padding-right: 11px;
  border-radius: var(--root-br);
  background: var(--grad-primary-n);
  color: white;
`;
export const StatusWrap = s.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.color.primary_3};
  padding: 10px 12px;
  border-top-right-radius: var(--root-br);
  border-bottom-left-radius: var(--root-br);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  @media(max-width: 1199px) and (min-width: 991px) {
    padding: 10px 5px;
  }
  @media(max-width: 480px) {
    flex-direction: column;
  }
`;
export const Status = s.span`
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: .5px;
`;
export const Timing = s.time`
  display: block;
  color: white;
  font-weight: 500;
  margin-bottom: 5px;
`;

export const StyledCollapse = s(Collapse)`
  box-shadow: none;
  margin-top: 10px;
  background: ${({ theme }) => theme.color.primary_3};
  h2 {
    font-weight: 500;
  }
`;

export const InfoBadge = s(CircleButton)`
  cursor: help;
`;

export const CloseableMessage = s(BaseCloseableMessage)`
  display: inline-flex;
  margin-top: 10px;
  margin-bottom: 0;
`;
